import React from 'react';
import DOMPurify from 'dompurify';
import "../../../styles/article-database.css";

const ArticleDatabase = ({article}) => {
    return <div className='container-generic' dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(article.Contenu)}}/>
}

export default ArticleDatabase;